import { getUser } from 'utils/authService'
import { utcCurrentDate } from 'utils/helpers'

export const toDeal = deal => {
  return {
    address: deal.address,
    city: deal.city,
    name: deal.name,
    state: deal.state,
    dealCompanies: toCompanies(deal.clients),
    dealManagerId: getUser().id,
    dealStatus: 'NEW',
    dueDate: deal.dueDate ?? utcCurrentDate(),
    quoteNumber: deal.quoteNumber
  }
}

export const toCompanies = companies =>
  companies.map(company => {
    return {
      companyId: company.value,
      dealContacts: toContacts(company.selectedContacts || [])
    }
  })

const toContacts = contacts =>
  contacts.map(contact => {
    return {
      contactId: contact.value
    }
  })
